<template>
    <picture>
        <source
            :srcset="imageData?.src + '.webp'"
            type="image/webp"
            media="(min-width: 1025px)" />
        <source
            :srcset="imageData?.src + '.jpg'"
            media="(min-width: 1025px)" />
        <source
            :srcset="imageData?.src + '-tablet.webp'"
            type="image/webp"
            media="(min-width: 768px)" />
        <source
            :srcset="imageData?.src + '-tablet.jpg'"
            media="(min-width: 768px)" />
        <source
            :srcset="imageData?.src + '-mobile.webp'"
            type="image/webp" />
        <img
            :src="imageData?.src + '-mobile.jpg'"
            :alt="imageData?.alt"
            :title="imageData?.alt"
            :width="imageData?.width"
            :height="imageData?.height">
    </picture>
</template>

<script>
    export default {
        name: 'PictureHelper',
        props: {
            imageData: Object
        }
    }
</script>